import { mapState } from 'vuex'

// see dbo.Roles table
const nucleusUser = ['20FF5C78-DC56-4533-856B-1E9EC0E93356', 8]
const documentManagerAdmin = ['74D6B1F8-EA97-4E23-A41A-5AD80CD1BE06', 1]
const codingLogs = ['0B344834-F5B0-48F0-A6CF-34941EB95995', 3]
const codingSchedule = ['5D84DC67-B42B-4AB8-9BFD-BA3855D68F9D', 4]
const reviewSchedule = ['F5016BB8-845D-4B0A-BB24-82C789C69B6B', 5]
const invoice = ['385B92F0-B9A4-4367-ACCF-CDE38CF74537', 6]
const ar = ['6EDF1BFA-A69E-4284-A90A-4637DCEFFBE0', 7]
const betaFeatures = ['2C743F4C-1910-4DDD-94CF-F487A482FF82', 10]
const codingDashboard = ['3AC31250-46D9-4E94-B8C7-9C1F580EF508', 11]
const reviewDashboard = ['2E5947A8-6721-45B3-ABD8-04B5A2252CDE', 12]
const userAdmin = ['EABDA001-1BA7-4CD3-A0FD-A4E920C55A68', 13]
const documentAdmin = ['CE97FD50-5C59-42CB-9B42-B870A3DD6306', 17]
const rebuttalUser = ['F5280AB1-255E-4A97-99B4-78CA99FCA196', 21]
const rebuttalManager = ['01BC66A5-B753-45A2-BF0E-E6CD88AC30D1', 22]
const codingQuestions = ['77190CC1-53DA-4BEE-B507-5AA85F5C8BB0', 24]

var HiaAuthorization = {
  methods: {
    getUserRoles: function() {
      if (!this.user.roles) return []

      // Handle format: [[zpawl, [1,2]], ...]
      return this.user.roles.flatMap(([client, roleIds]) =>
        roleIds.map(roleId => ({
          ClientNumber: client,
          RoleId: roleId
        }))
      )
    },
    ITUser: function() {
      return ['auth0|5c5ca22de3b37a707f82face', 'auth0|5c2cd31fc12e3e5be73e68e3', 'auth0|5c8814b576285420a5e2175c', 'auth0|5c252704c12e3e5be73e2eaf'].includes(this.user.auth0Id)
    },
    betaFeatures: function() {
      if (this.ITUser()) {
        return true
      }
      return this.getUserRoles().some(x => x.ClientNumber === 'zpawl' && x.RoleId === betaFeatures[1])
    },
    documentManagerAdmin: function() {
      return this.getUserRoles().some(x => x.ClientNumber === 'zpawl' && x.RoleId === documentManagerAdmin[1])
    },
    reviewDashboard: function() {
      return this.userInGroup(reviewDashboard)
    },
    codingDashboard: function() {
      return this.userInGroup(codingDashboard)
    },
    codingLogs: function() {
      return this.userInGroup(codingLogs)
    },
    codingSchedule: function() {
      return this.userInGroup(codingSchedule)
    },
    reviewSchedule: function() {
      return this.userInGroup(reviewSchedule)
    },
    invoice: function() {
      return this.userInGroup(invoice)
    },
    ar: function() {
      return this.userInGroup(ar)
    },
    userAdmin: function() {
      return this.userInGroup(userAdmin)
    },
    documentAdmin: function() {
      return this.userInGroup(documentAdmin)
    },
    rebuttalUser: function() {
      return this.userInGroup(rebuttalUser)
    },
    rebuttalManager: function() {
      return this.userInGroup(rebuttalManager)
    },
    nucleusUser: function() {
      return this.userInGroup(nucleusUser)
    },
    userInRoleByClient(client, roleId) {
      if (this.getUserRoles().some(x => x.ClientNumber === client && x.RoleId === roleId)) {
        return true
      }

      return false
    },
    userInGroup(group) {
      if (this.getUserRoles().some(x => x.ClientNumber === this.currentClient && x.RoleId === group[1])) {
        return true
      }

      // for the user admin group, don't worry about the client number
      if (this.getUserRoles().some(x => x.RoleId === group[1]) && group[1] === userAdmin[1]) {
        return true
      }

      // for the rebuttal user in zpawl (HIA Coders), don't worry about the client number
      if (this.getUserRoles().some(x => x.ClientNumber === 'zpawl' && x.RoleId === group[1]) && group[1] === rebuttalUser[1]) {
        return true
      }

      if (this.documentManagerAdmin() || this.ITUser()) {
        return true
      }
      return false
    },
    isUserAdminClient(client) {
      if (this.getUserRoles().some(x => x.ClientNumber === client && (x.RoleId === userAdmin[1] || x.RoleId === rebuttalManager[1]))) {
        return true
      }
    },
    isHIAUser() {
      return this.user && this.user.email && this.user.email.includes('hiacode.com')
    },
    isCodingQuestion() {
      return this.userInGroup(codingQuestions)
    }
  },
  computed: {
    ...mapState('user/', ['user', 'currentClient'])
  }
}

export default HiaAuthorization
